import React, {Component} from 'react';
import {Form, Row, Col} from 'react-bootstrap';


export default class TextField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			feedbackSuccess,
			meta: {error, warning, touched, asyncValidating},
			sizes,
			onChangeHook,
			className,
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || (!props.disabled && feedbackSuccess && input.value ? "success" : null) : null;
		// const icon = feedbackIcon ? feedbackIcon : ((!props.disabled && validationState === "success" && feedbackSuccess && input.value) ? <span className="fa fa-ok"/> : null)

		if (touched && (error || warning)) {
			message = error || warning
		}

		const labelS = sizes && sizes[0] !== undefined ? sizes[0] : 4;
		const inputS = sizes && sizes[1] !== undefined ? sizes[1] : 8;
		return (
			<Form.Group as={Row} controlId={input.name} className={asyncValidating ? "loading" : null}>
				{label && labelS ? <Form.Label column xs={labelS}>{label}</Form.Label> : null}
				<Col xs={inputS}>
					<Form.Control {...props} {...input}
						placeholder={input.placeholder ? input.placeholder : (!labelS && label ? label : null)}
						className={className + (touched && error ? " is-invalid" : "")}
						onChange={(value) => {
							if (onChangeHook) {
								onChangeHook(value)
							}
							input.onChange(value)
						}}/>
					{message ? <div className={"text-" + validationState}>{message}</div> : null}
				</Col>
			</Form.Group>
		);
	}
}
